import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scoringApi = (token) => {
  const h = { headers: { "X-Admin-Token": token } };
  return {
    get: (p, params) => axios.get(`${API}${p}`, { ...h, params }).then((r) => r.data),
    post: (p, b) => axios.post(`${API}${p}`, b, h).then((r) => r.data),
    put: (p, b) => axios.put(`${API}${p}`, b, h).then((r) => r.data),
    del: (p) => axios.delete(`${API}${p}`, h).then((r) => r.data),
  };
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : "Something went wrong. Try again.";
};

export const publicBoard = (token) => axios.get(`${API}/scoreboard/${token}`).then((r) => r.data);

export const DISC_LABEL = { hitting: "Hitting", pitching: "Pitching" };

export const pill = (on) =>
  `rounded-full px-4 py-2 text-sm font-bold transition-colors ${on ? "bg-[#2563EB] text-white" : "border border-slate-300 text-slate-600 hover:text-[#0B0F19]"}`;

export const inputCls = "w-full bg-white border border-slate-200 rounded-xl px-4 py-3 text-[#0B0F19] placeholder-slate-400 outline-none focus:border-[#2563EB]";

export const RANGES = [["all", "All time"], ["cycle", "Current 4-week program"], ["30", "Last 30 days"], ["7", "Last 7 days"], ["session", "Single session"], ["custom", "Custom dates"]];
export const STATUS = { draft: "Draft", live: "In Progress", closed: "Completed" };
const SHORT = { strikeout: "K", weak_ground_ball: "Weak GB", hard_ground_ball: "Hard GB", fly_ball: "Fly Ball", line_drive: "Line Drive", extra_base: "XBH",
  strike_located: "Strike · Located", strike_missed: "Strike · Missed Loc", ball_located: "Ball · On Loc", ball_missed: "Ball · Missed Loc" };
export const shortLabel = (o) => SHORT[o.key] || o.label;
export const EMPTY_FILTERS = { range: "all", start: "", end: "", session_id: "", program_id: "", division: "", group_ids: [], q: "" };
export const toParams = (discipline, f) => ({ discipline, ...f, group_ids: (f.group_ids || []).join(",") });
export const ready = (f) => (f.range !== "session" || f.session_id) && (f.range !== "custom" || (f.start && f.end));
export const niceDate = (d) => (d ? new Date(`${d}T12:00:00Z`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }) : "");
export const rangeText = (f, range, fallback) => (fallback ? "All time (no 4-week program yet)" : f.range === "all" ? "All time" : f.range === "session" ? "This session" : range ? `${niceDate(range[0])} – ${niceDate(range[1])}` : RANGES.find((r) => r[0] === f.range)?.[1]);
